// Enums
import { EnvName } from '@enums/environment.enum';

// Packages
import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  appName: 'Navigator',
  envName: EnvName.DEV,
  defaultLanguage: 'de',
  apiBaseUrl: 'https://api.navigator.dev.s-marketing.ch',
  instanceUuid: '5e042a62-b749-11f1-9eb7-0e6b4eaa0fa5',
  gaId: 'G-7SRR4FL8E7',
};
